var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91669 5.83332H4.08335C5.25002 5.83332 5.83335 5.24999 5.83335 4.08332V2.91666C5.83335 1.74999 5.25002 1.16666 4.08335 1.16666H2.91669C1.75002 1.16666 1.16669 1.74999 1.16669 2.91666V4.08332C1.16669 5.24999 1.75002 5.83332 2.91669 5.83332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91669 5.83332H11.0834C12.25 5.83332 12.8334 5.24999 12.8334 4.08332V2.91666C12.8334 1.74999 12.25 1.16666 11.0834 1.16666H9.91669C8.75002 1.16666 8.16669 1.74999 8.16669 2.91666V4.08332C8.16669 5.24999 8.75002 5.83332 9.91669 5.83332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91669 12.8333H11.0834C12.25 12.8333 12.8334 12.25 12.8334 11.0833V9.91666C12.8334 8.74999 12.25 8.16666 11.0834 8.16666H9.91669C8.75002 8.16666 8.16669 8.74999 8.16669 9.91666V11.0833C8.16669 12.25 8.75002 12.8333 9.91669 12.8333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91669 12.8333H4.08335C5.25002 12.8333 5.83335 12.25 5.83335 11.0833V9.91666C5.83335 8.74999 5.25002 8.16666 4.08335 8.16666H2.91669C1.75002 8.16666 1.16669 8.74999 1.16669 9.91666V11.0833C1.16669 12.25 1.75002 12.8333 2.91669 12.8333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.81b8cda652a40673d112bef2f1b54d44.svg";
export { ForwardRef as ReactComponent };